module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Аккаунты расширения Blacklist без привязки к Telegram.")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n         Подключено: " + _vm._s(_vm.items.length) + "     \n         Оплачено: " + _vm._s(Number(_vm.accCount) + Number(_vm.items.length)) + " (" + _vm._s(_vm.accCount) + ")\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "brown lighten-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "deep-orange darken-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": "",
      "title": "Добавить сотрудника в команду"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_vm._v("Nick name")]), _vm._v(" "), _c('th', [_vm._v("Последний доступ:")]), _vm._v(" "), _c('th', [_vm._v("Оплачено до:")]), _vm._v(" "), _c('th', [_vm._v("Код авторизации:")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "280"
          }
        }, [_c('v-text-field', {
          attrs: {
            "name": "nick_name",
            "hide-details": ""
          },
          on: {
            "input": function($event) {
              _vm.changeInput(props.item, 'nick_name')
            }
          },
          model: {
            value: (props.item.nick_name),
            callback: function($$v) {
              _vm.$set(props.item, "nick_name", $$v)
            },
            expression: "props.item.nick_name"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.last_access) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.paid_until) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_c('b', [_vm._v(" " + _vm._s(props.item.auth) + " ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          attrs: {
            "fab": "",
            "small": "",
            "flat": "",
            "title": "Удалить сотрудника из команды"
          },
          nativeOn: {
            "click": function($event) {
              _vm.remove(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('confirm-dialog', {
    attrs: {
      "dialog": _vm.dialog,
      "dialogTitle": _vm.dialogTitle,
      "dialogText": _vm.dialogText
    },
    on: {
      "onConfirm": _vm.onConfirm,
      "onCancel": _vm.onCancel
    }
  }), _vm._v(" "), (_vm.snackbar) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-ce3547d8","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Extention.vue
// module id = 424
// module chunks = 0